export default __webpack_public_path__ + "static/media/lekhaj.eabc1cdd.png";